import * as React from "react";
import { IconProps } from "./types";

export const GridDotsBottomIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M3 3H3.01M3 12H3.01M3 16.5H3.01M3 7.5H3.01M7.5 3H7.51M7.5 12H7.51M16.5 3H16.51M16.5 12H16.51M12 3H12.01M12 12H12.01M12 16.5H12.01M12 7.5H12.01M21 3H21.01M21 12H21.01M21 16.5H21.01M21 7.5H21.01M21 21H3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(GridDotsBottomIcon as React.FunctionComponent).displayName =
  "GridDotsBottomIcon";

export default GridDotsBottomIcon;
